// Randomises product order inside .sf-mixed-layout__wrapper sections.
// Performance update (HEROZ SEO/CWV, Sep 2026): the shuffle used to run for every section at page load,
// re-inserting all product cards and blocking the main thread. It now runs per section, just before
// that section scrolls into view (after the visitor first interacts), so it no longer competes with page load.
(function () {
  function shuffleWrapper(wrapper) {
    const isSwiper = wrapper.classList.contains('swiper-wrapper') || wrapper.closest('.swiper-wrapper');
    const productElements = isSwiper
      ? wrapper.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)')
      : wrapper.children;

    const products = Array.from(productElements);
    if (products.length <= 1) return;

    const seen = new Set();
    const unique = [];
    const duplicates = [];

    for (let product of products) {
      let productKey = product.dataset.productId || product.dataset.productId__c;
      if (!productKey) {
        const link = product.querySelector('a[href*="/products/"]');
        if (link) {
          const match = link.href.match(/\/products\/([^/?#]+)/);
          if (match) productKey = match[1];
        }
        if (!productKey) productKey = product.textContent.trim().slice(0, 50);
      }
      (seen.has(productKey) ? duplicates : unique).push(product);
      seen.add(productKey);
    }
    for (let i = unique.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [unique[i], unique[j]] = [unique[j], unique[i]];
    }
    const allProducts = [...unique, ...duplicates];
    if (isSwiper) {
      const container = wrapper.closest('.swiper-container');
      const swiper = container && container.swiper;
      if (swiper) {
        swiper.removeAllSlides();
        swiper.appendSlide(allProducts);
        swiper.update();
      } else if ((wrapper._hzTries = (wrapper._hzTries || 0) + 1) < 20) {
        // Slider not initialised yet: try again shortly.
        setTimeout(() => shuffleWrapper(wrapper), 300);
      }
    } else {
      const fragment = document.createDocumentFragment();
      allProducts.forEach(product => fragment.appendChild(product));
      wrapper.replaceChildren(fragment);
    }
  }

  function init() {
    const wrappers = document.querySelectorAll('.sf-mixed-layout__wrapper');
    if (!wrappers.length) return;
    if (!('IntersectionObserver' in window)) {
      wrappers.forEach(shuffleWrapper);
      return;
    }
    const io = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          shuffleWrapper(entry.target);
        }
      });
    }, { rootMargin: '0px 0px 300px 0px' });
    wrappers.forEach(w => io.observe(w));
  }

  // Start only after the visitor first interacts (scroll, touch, click or key).
  // Product sections sit below the banner, so they are still shuffled before they come into view,
  // but none of this work competes with the initial page load.
  let started = false;
  const events = ['scroll', 'touchstart', 'pointerdown', 'keydown', 'wheel'];
  function start() {
    if (started) return;
    started = true;
    events.forEach(e => window.removeEventListener(e, start, { passive: true }));
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }
  events.forEach(e => window.addEventListener(e, start, { passive: true, once: true }));
})();
